import React from 'react'

const TwitterIcon = ({ className }) => (
  <svg version="1" width="17.5" height="14.2">
    <title>Share to Twitter icon </title>
    <path
      className="st0"
      d="M15.7 3.5V4c0 4.8-3.6 10.2-10.2 10.2-2 0-3.9-.6-5.5-1.6h.9c1.7 0 3.2-.6 4.5-1.5-1.6 0-2.9-1.1-3.4-2.5.2 0 .4.1.7.1.3 0 .6 0 .9-.1C1.9 8.2.7 6.8.7 5c.5.3 1 .4 1.6.5-1-.6-1.6-1.7-1.6-3 0-.7.2-1.3.5-1.8C3 2.8 5.7 4.3 8.6 4.4c0-.3-.1-.5-.1-.8 0-2 1.6-3.6 3.6-3.6 1 0 2 .4 2.6 1.1.9-.1 1.7-.4 2.3-.8-.3.8-.8 1.5-1.6 2 .7-.1 1.4-.3 2.1-.6-.5.7-1.1 1.3-1.8 1.8z"
    />
  </svg>
)

export default TwitterIcon
